import * as BaseSizes from './Size';

export const Size = {
  XXSmall: BaseSizes.XSmall,
  XSmall: BaseSizes.Small,
  Small: BaseSizes.Medium,
  MediumSmall: BaseSizes.Large,
  Medium: BaseSizes.XLarge,
  MediumLarge: BaseSizes.X2Large,
  Large: BaseSizes.X4Large,
  XLarge: BaseSizes.X6Large,
  XXLarge: BaseSizes.X7Large,
  XXXLarge: BaseSizes.X8Large,
};

export const Type = {
  /**
   * Used for spacing between boxes
   * Applies to margin top and bottom
   */
  Section: 10,
};
